import React, { useState, useRef } from 'react';
import { Button } from "src/components/ui/button";
import { Plus } from "lucide-react";
import IOTable, { IOTableRef } from '../components/io-table';
import SearchInput from "../../../components/search-input/search-input";
import { TabControlsContainer } from 'src/components/tab-controls/tab-controls-container';

const InsertionOrdersTab: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const ioTableRef = useRef<IOTableRef>(null);

  const handleCreateNewInsertionOrder = () => {
    ioTableRef.current?.createNew();
  };

  return (
    <div className="h-full flex flex-col space-y-4">
      {/* Header */}
      <div className="flex justify-between items-center">
        {/* Controls */}
        <TabControlsContainer>
          <div className="flex gap-4 w-full">
            <SearchInput
              placeholder="Search insertion orders..."
              value={searchValue}
              onChange={setSearchValue}
              debounceMs={500}
              className="w-96"
              inputClassName='bg-gray-300 rounded-xl'
            />
            <div className="flex items-center gap-4 ml-auto">
              <div className="h-6 border-l border-gray-300" />

              <Button
                size="med"
                variant="create"
                onClick={handleCreateNewInsertionOrder}
                className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium transition-colors"
              >
                <Plus className="h-4 w-4" />
                New IO
              </Button>
            </div>
          </div>
        </TabControlsContainer>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto relative">
        <IOTable
          ref={ioTableRef}
          searchValue={searchValue}
        />
      </div>
    </div>
  );
};

export default InsertionOrdersTab;